import styled from "styled-components";

import { ICON_HEIGHT } from "./_constants";

const IconCopy = styled.img.attrs({
  src: "/assets/images/icon-duplicate.png",
  title: "Clone"
})`
  cursor: pointer;
  height: ${ICON_HEIGHT}px;
`;
IconCopy.displayName = "IconCopy";

export default IconCopy;
